import { CanMatchFn } from '@angular/router';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage/storage.service';

export const isAuthenticatedGuard: CanMatchFn = () => {
  const isAuthenticated = inject(StorageService).getAuthToken();

  return !!isAuthenticated;
};
